import log from 'loglevel';
import { gunzip } from 'fflate';
import { atob } from 'js-base64';

const urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let probe = null;

function currentScript() {
  if (typeof document === 'undefined') return;
  if (document.currentScript) return document.currentScript;
  // IE 处理
  try {
    throw new Error();
  } catch (err) {
    // ie 11
    const stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(err.stack);
    const scriptLocation = (stackDetails && stackDetails[1]) || false;
    const nodes = document.getElementsByTagName('script');
    // eslint-disable-next-line
    for (var i = 0, node; (node = nodes[i++]); ) {
      // ie 8-10
      if (node.readyState === 'interactive') return node;
      // ie 11
      if (node.src === scriptLocation) return node;
    }
  }

  return null;
}

// eslint-disable-next-line
export function vhallBaseBlock() {
  const id = 'VhallBaseSDK';
  if (typeof document === 'undefined') return;
  const currEl = currentScript();
  if (!currEl) return;
  const originId = currEl.id;
  currEl.id = '';
  const elById = document.getElementById(id);
  if (elById && elById !== currEl) return;
  if (!elById) currEl.id = originId || id;
}

export function checkDevice() {
  let device;
  if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
    // 判断是否是移动设备打开。browser代码在下面
    var ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.match(/MicroMessenger/i) === 'micromessenger') {
      device = 'wechat_browser';
      return device;
    }
    device = 'h5_browser';
  } else {
    device = 'pc_browser';
  }
  return device;
}

export const systemProbe = function () {
  if (probe) return probe;
  probe = {};
  if (document.all || window.msCrypto) {
    probe.ieVseion = 11;
    if (!document.all) probe.ieVseion = 10;
  } else {
    probe.ieVseion = 0;
  }

  return probe;
};

export function getParams(url, key, sp) {
  if (!sp) sp = '&';
  if (typeof url !== 'string') return '';
  const pos = url.indexOf('?');
  const arr = url
    .slice(pos + 1)
    .split(sp)
    .map(i => i.split('='));
  for (const [k, v] of arr) {
    if (k === key) return v;
  }
  return '';
}

export function nanoid(size = 20) {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id;
}

export const pageSession = nanoid(20);

/**
 * 解压数据
 * @param {*} data
 * @returns
 */
export async function decompressData(data) {
  return new Promise((resolve, reject) => {
    gunzip(data, (err, decompressedData) => {
      if (err) {
        reject(err);
      } else {
        resolve(decompressedData);
      }
    });
  });
}

/**
 * 安全的json转换
 * @param {*} val
 */
export const safeJsonParse = function (val) {
  const type = Object.prototype.toString.call(val);
  if (['[object Array]', '[object Object]', '[object Null]'].includes(type)) return val;
  try {
    return JSON.parse(val);
  } catch (ex) {
    return null;
  }
};

export const toUint8ArrayExt = function (a) {
  try {
    a = a.replace(/[^A-Za-z0-9+/]/g, '').replace(/[-_]/g, m0 => (m0 == '-' ? '+' : '/'));
    const it =
      typeof Buffer === 'function'
        ? Buffer.from(a, 'base64')
        : atob(a)
            .split('')
            .map(c => c.charCodeAt(0));
    return new Uint8Array(Array.prototype.slice.call(it, 0));
  } catch (ex) {
    log.error('toUint8ArrayExt exec error:', ex);
  }
  return undefined;
};

export const formatTime = function (date, format = 'HH:MM:SS.sss') {
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

  let formatted = format;
  formatted = formatted.replace('HH', hours).replace('MM', minutes).replace('SS', seconds).replace('sss', milliseconds);
  return formatted;
};
